export class NotificationAlertsMessage {
    type: string = 'error';
    subType: string = '';
    text: string = '';
    timeout: number = 12000;

    constructor(partialNotificationAlertsMessage: Partial<NotificationAlertsMessage>) {
        Object.assign(this, partialNotificationAlertsMessage);
    }
}
